/*
 * @Author: zhenfangyu 2211267244@qq.com
 * @Date: 2024-07-08 09:51:59
 * @LastEditors: zhenfangyu 2211267244@qq.com
 * @LastEditTime: 2024-07-12 18:12:50
 * @FilePath: \jzt-kf-h5\src\utils\common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @description: 生成随机数
 * @return {*}
 */
export function generateTimestampPlusRandom() {
  // 获取当前时间的时间戳
  const timestamp = Date.now()
  // 生成一个5位的随机数，范围是10000到99999
  const randomPart = Math.floor(10000 + Math.random() * 90000)
  // 拼接时间戳和随机数
  const result = timestamp.toString() + randomPart.toString()
  return result
}
let timeoutId
let isFirstCall = true
export function antiShake(fun, time = 1000) {
  if (isFirstCall) {
    fun()
    isFirstCall = false
  } else {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fun()
      isFirstCall = true
    }, time)
  }
}
export function clearTimeoutId() {
  timeoutId && clearTimeout(timeoutId)
}

export function withClickCooldown(fn, wait = 3000, onCooldown) {
  let isWaiting = false

  return function(...args) {
    if (isWaiting) {
      onCooldown && onCooldown()
      return
    }

    isWaiting = true
    fn.apply(this, args)

    setTimeout(() => {
      isWaiting = false
    }, wait)
  }
}
